import { useTranslation } from 'react-i18next';

const LoggedOutPage = () => {
  const { t } = useTranslation();
  
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>{t("loggedout:messages.loggedOut")}</h1>
    </div>
  );
};

export default LoggedOutPage;